import { createContext, ReactNode, useState } from "react";
import { IBreadcrumbItem } from "dash-ui";

import { useBreadcrumbBuilder } from "common/hooks/use-breadcrumb-builder";

import { IBreadcrumbContext } from "./breadcrumb-context.interfaces";

const defaultContextValue = {
  isSticky: false,
  breadcrumbItems: [],
  setBreadcrumbItems: (activeItems: IBreadcrumbItem[]) => activeItems,
  setIsSticky: (value: boolean) => {},
};

const BreadcrumbContext =
  createContext<IBreadcrumbContext>(defaultContextValue);

const BreadcrumbProvider = ({ children }: { children: ReactNode }) => {
  const [isSticky, setIsSticky] = useState(false);
  const [breadcrumbItems, setBreadcrumbItems] = useBreadcrumbBuilder();

  return (
    <BreadcrumbContext.Provider
      value={{ isSticky, setIsSticky, breadcrumbItems, setBreadcrumbItems }}
    >
      {children}
    </BreadcrumbContext.Provider>
  );
};

export { BreadcrumbContext, BreadcrumbProvider };
